import React from 'react';
import { useTranslation } from '../localization/useAppTranslation';

export interface TypingIndicatorProps {
  content?: string;
  className?: string;
}

/**
 * Typing indicator component showing that the assistant is thinking.
 */
export const TypingIndicator = React.forwardRef<
  HTMLDivElement,
  TypingIndicatorProps
>(({ content, className = '' }, ref) => {
  const { t } = useTranslation('chat');
  const displayContent = content ?? t('status.thinking');
  const indicatorClass = ['typing-indicator', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      ref={ref}
      className={indicatorClass}
      role="status"
      aria-busy="true"
      aria-label={displayContent || t('status.thinkingAriaLabel')}
    >
      <div className="typing-dots">
        <span className="dot" aria-hidden="true"></span>
        <span className="dot" aria-hidden="true"></span>
        <span className="dot" aria-hidden="true"></span>
      </div>
      {displayContent && <p className="typing-text">{displayContent}</p>}
    </div>
  );
});

TypingIndicator.displayName = 'TypingIndicator';
